import PropertyType from '../Modifiers/PropertyType.js';

var ThemePageFontBody = new PropertyType({
  name: 'PageFontBody',
  propertyFromApi: 'page-font-body',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return "font-family: " + value + ";";
  },
  selector: 'p, span, label, div, input, li, ol',
  cssVariable: '--page-font-body'
}, 'theme');
var FormPageFontBody = new PropertyType({
  name: 'PageFontBody',
  propertyFromApi: 'page-font-body',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return "font-family: " + value + ";";
  },
  selector: 'p, span, label, div, input, li, ol',
  cssVariable: '--page-font-body'
}, 'form');

export { FormPageFontBody, ThemePageFontBody };
//# sourceMappingURL=PageFontBody.js.map
